import React from "react";
import OperationalDocumentEditor from "../common/OperationalDocumentEditor";
import { BonConsumForm } from "./Form";
import BonConsumHelp from "./BonConsumHelp";

export default function BonConsumEdit() {
  return <OperationalDocumentEditor kind="consumption" FormComponent={BonConsumForm} HelpComponent={BonConsumHelp} />;
}
